"use client";

// src/components/Button/button.style.ts
import { tv } from "tailwind-variants";
var button = tv({
  base: "font-medium bg-button-primary-color text-white rounded-full active:opacity-80 h-[46px]",
  variants: {
    color: {
      primary: "bbg-button-primary-color text-white",
      secondary: "bg-purple-500 text-white",
      ghost: "bg-transparent text-button-primary-color"
    },
    size: {
      sm: "text-sm",
      md: "text-base",
      lg: "px-4 py-3 text-lg"
    }
  },
  compoundVariants: [
    {
      size: ["sm", "md"],
      class: "px-3 py-1"
    }
  ],
  defaultVariants: {
    size: "md",
    color: "primary"
  }
});

export {
  button
};
